"use client";

import { useEffect, useState } from "react";
import axios from "axios";
import { FaTrash, FaMoneyBillWave, FaFileDownload } from "react-icons/fa";
import "../styles/FinanceiroDono.css"; // aproveitando estilo do financeiro

const DespesasAdmin = () => {
  const [eventos, setEventos] = useState([]);
  const [eventoSelecionado, setEventoSelecionado] = useState("");
  const [descricao, setDescricao] = useState("");
  const [valor, setValor] = useState("");
  const [despesas, setDespesas] = useState([]);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    fetchEventos();
  }, []);

  useEffect(() => {
    if (eventoSelecionado) fetchDespesas();
  }, [eventoSelecionado]);

  const fetchEventos = async () => {
    try {
      const token = localStorage.getItem("token");
      const res = await axios.get("https://api.ticketdovaqueiro.com/api/events", {
        headers: { Authorization: `Bearer ${token}` },
      });
      setEventos(res.data);
    } catch (err) {
      console.error("Erro ao carregar eventos:", err);
    }
  };

  const fetchDespesas = async () => {
    try {
      const token = localStorage.getItem("token");
      const res = await axios.get(
        `https://api.ticketdovaqueiro.com/api/despesas/${eventoSelecionado}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setDespesas(res.data);
      const soma = res.data.reduce((acc, d) => acc + d.valor, 0);
      setTotal(soma);
    } catch (err) {
      console.error("Erro ao carregar despesas:", err);
    }
  };

  const salvarDespesa = async () => {
    try {
      const token = localStorage.getItem("token");
      await axios.post(
        "https://api.ticketdovaqueiro.com/api/despesas",
        { evento: eventoSelecionado, descricao, valor: parseFloat(valor) },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setDescricao("");
      setValor("");
      fetchDespesas();
    } catch (err) {
      console.error("Erro ao salvar despesa:", err);
    }
  };

  const excluirDespesa = async (despesa) => {
    const id = despesa?._id || despesa?.syncKey;
    if (!id) return;

    const origem = despesa?.origem === "programa" ? "criada no programa/desktop" : "criada no site";
    const confirmar = window.confirm(
      `Deseja realmente excluir esta despesa (${origem})?

` +
      `Descrição: ${despesa?.descricao || "-"}
` +
      `Valor: R$ ${(Number(despesa?.valor) || 0).toFixed(2)}

` +
      "Ela deixará de aparecer no site e será sincronizada como removida para o desktop."
    );

    if (!confirmar) return;

    try {
      const token = localStorage.getItem("token");
      await axios.delete(`https://api.ticketdovaqueiro.com/api/despesas/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      fetchDespesas();
    } catch (err) {
      console.error("Erro ao excluir despesa:", err);
      alert(err?.response?.data?.erro || err?.response?.data?.mensagem || "Erro ao excluir despesa.");
    }
  };

  const handleBaixarPdf = () => {
    if (!eventoSelecionado) return;
    const url = `https://api.ticketdovaqueiro.com/api/relatorios/despesas-pdf?eventoId=${encodeURIComponent(
      eventoSelecionado
    )}`;
    window.open(url, "_blank");
  };

  return (
    <div className="financeiro-containerdono">
      <h2>
        <FaMoneyBillWave /> Gestão de Despesas
      </h2>

      {/* Filtro de Evento + botão PDF */}
      <div className="descricao-extrato">
        <label>Selecione o Evento:</label>
        <select
          value={eventoSelecionado}
          onChange={(e) => setEventoSelecionado(e.target.value)}
        >
          <option value="">-- Escolha um evento --</option>
          {eventos.map((evento) => (
            <option key={evento._id} value={evento._id}>
              {evento.nome}
            </option>
          ))}
        </select>

        <button
          className="botao-saque"
          onClick={handleBaixarPdf}
          disabled={!eventoSelecionado}
          style={{ marginLeft: 12 }}
          title="Baixar PDF com todas as despesas deste evento"
        >
          <FaFileDownload /> Baixar PDF de Despesas
        </button>
      </div>

      {eventoSelecionado && (
        <>
          {/* Total */}
          <div className="grid-itemdono destaque">
            <h4>Total de Despesas</h4>
            <p>R$ {total.toFixed(2)}</p>
          </div>

          {/* Formulário */}
          <div className="descricao-extrato">
            <input
              type="text"
              placeholder="Descrição"
              value={descricao}
              onChange={(e) => setDescricao(e.target.value)}
            />
            <input
              type="number"
              placeholder="Valor"
              value={valor}
              onChange={(e) => setValor(e.target.value)}
            />
            <button className="botao-saque" onClick={salvarDespesa}>
              Adicionar
            </button>
          </div>

          {/* Tabela */}
          <div className="table-responsive">
            <table className="extrato-tabela">
              <thead>
                <tr>
                  <th>Descrição</th>
                  <th>Valor</th>
                  <th>Data/Hora</th>
                  <th>Ação</th>
                </tr>
              </thead>
              <tbody>
                {despesas.map((d) => (
                  <tr key={d._id}>
                    <td>{d.descricao}</td>
                    <td>R$ {d.valor.toFixed(2)}</td>
                    <td>{new Date(d.dataCriacao).toLocaleString("pt-BR")}</td>
                    <td>
                      <FaTrash
                        className="icone-acao vermelho"
                        onClick={() => excluirDespesa(d)}
                        style={{ cursor: "pointer" }}
                        title={d.origem === "programa" ? "Excluir despesa criada no programa/desktop" : "Excluir despesa"}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
};

export default DespesasAdmin;
